// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4243":"css/admin-app.7014","7574":"css/app.7014"}[chunkId] + ".css";
};